import { WPMenuItem } from 'types/menus';

export const createSocialLink = (url: string, type: string) => {
  return url + type;
};

export const cleanExternalLink = (url: string) => {
  return url.includes('http') && url.startsWith('/') ? url.substring(1) : url;
};

export const createMenuLink = (item: WPMenuItem, parent?: string) => {
  if (item.type === 'custom' && !item.slug) {
    return item.url;
  }
  if (item.type === 'custom' && !item?.slug) {
    return `/${item.slug}`;
  }
  if (item.slug && parent) {
    return `/${parent}/${item.slug}`;
  }
  return `/${item.slug}`;
};
